import { TableCell } from '@mui/material';

export default function MerchantCell({ row }) {
  return (
    <TableCell>
      <div className="transactionMerchantCell">
        <p>{row?.merchant}</p>
      </div>
    </TableCell>
  );
}
